export const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇺🇸', svg: 'us' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪', svg: 'de' },
];

export const translations = {
  en: {
    nav: {
      shippingWorldwide: 'Shipping to 200+ Countries Worldwide',
      home: 'Home',
      track: 'Track',
      trackPackage: 'Track Package',
      contact: 'Contact',
      dashboard: 'Dashboard',
      logout: 'Logout',
      adminLogin: 'Admin Login',
      globalLogistics: 'Global Logistics Solutions',
    },
    footer: {
      globalLogistics: 'Global Logistics Solutions',
      description: 'Professional shipping and logistics services with real-time tracking, secure delivery, and exceptional customer support. Your trusted partner for all shipping needs worldwide.',
      ssl: '256-bit SSL',
      pciCompliant: 'PCI Compliant',
      ourServices: 'Our Services',
      standardDelivery: 'Standard Delivery',
      expressShipping: 'Express Shipping',
      overnightDelivery: 'Overnight Delivery',
      internationalShipping: 'International Shipping',
      freightServices: 'Freight Services',
      contactUs: 'Contact Us',
      berlinHQ: 'Berlin HQ — Germany',
      usaOffice: 'USA Office — 24/7 Support',
      emailSupport: 'Email Support',
      headquarters: 'Headquarters',
      berlinGermany: 'Berlin, Germany',
      rights: '© 2024 DutchCargoExpress. All rights reserved. Licensed & Insured.',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      cookiePolicy: 'Cookie Policy',
      shippingPolicy: 'Shipping Policy',
      trademark: 'DutchCargoExpress is a registered trademark. All shipping is subject to terms and conditions.',
    },
    home: {
      trustedBy: '🌍 Trusted by 10M+ customers worldwide',
      heroTitle: 'Global Logistics,',
      heroTitleAccent: 'Delivered With Precision',
      heroDesc: 'Air, sea and road freight solutions for businesses and individuals. Track your packages in real-time with our advanced logistics platform.',
      trackPlaceholder: 'Enter tracking number...',
      track: 'Track',
      orVisit: 'Or',
      visitTracking: 'visit our tracking page',
      ssl: '256-bit SSL',
      countries: '200+ Countries',
      onTime: '99.8% On-Time',
      whatWeMove: 'What We Move',
      freightSolutions: 'Freight Solutions For Every Route',
      freightDesc: 'From urgent air cargo to cost-effective ocean freight — we handle it end to end.',
      airFreight: 'Air Freight',
      airFreightDesc: 'Express worldwide delivery in 1–5 business days with priority customs handling.',
      seaFreight: 'Sea Freight',
      seaFreightDesc: 'Full-container and consolidated ocean shipping to every major port worldwide.',
      doorToDoor: 'Door-to-Door Delivery',
      doorToDoorDesc: 'Professional last-mile couriers ensuring your package arrives safely, signed and confirmed.',
      ourAdvantages: 'Our Advantages',
      whyChoose: 'Why Choose DutchCargoExpress?',
      whyChooseDesc: 'We provide world-class shipping services with cutting-edge technology and exceptional customer support.',
      realTimeTracking: 'Real-time Tracking',
      realTimeTrackingDesc: 'Track your packages in real-time with detailed location updates and delivery status.',
      secureDelivery: 'Secure Delivery',
      secureDeliveryDesc: 'Your packages are handled with care and delivered securely to the right recipient.',
      fastDelivery: 'Fast Delivery',
      fastDeliveryDesc: 'Multiple delivery options from same-day to economy shipping to meet your needs.',
      globalNetwork: 'Global Network',
      globalNetworkDesc: 'Worldwide shipping network covering 200+ countries and territories.',
      pricingPlans: 'Pricing Plans',
      ourServices: 'Our Shipping Services',
      chooseService: 'Choose the perfect shipping option for your needs',
      standardName: 'Standard International',
      standardTime: '7-14 business days',
      standardPrice: 'Starting at $185',
      expressName: 'Express International',
      expressTime: '3-5 business days',
      expressPrice: 'Starting at $350',
      premiumName: 'Premium International',
      premiumTime: '1-2 business days',
      premiumPrice: 'Starting at $595',
      featTracking: 'Package tracking',
      featDeliveryConf: 'Delivery confirmation',
      featBasicInsurance: 'Basic insurance',
      featCustoms: 'Customs clearance',
      featPriority: 'Priority handling',
      featRealTime: 'Real-time tracking',
      featSignature: 'Signature required',
      featGuaranteed: 'Guaranteed delivery',
      featPremiumTracking: 'Premium tracking',
      featFullInsurance: 'Full insurance',
      featPriorityCustoms: 'Priority customs',
      mostPopular: 'Most Popular',
      getStarted: 'Get Started',
      packagesDelivered: 'Packages Delivered',
      countriesServed: 'Countries Served',
      onTimeDelivery: 'On-Time Delivery',
      customerSupport: 'Customer Support',
      customerReviews: 'Customer Reviews',
      whatCustomersSay: 'What Our Customers Say',
      joinThousands: 'Join thousands of satisfied customers who trust us with their shipping needs',
      review1: '"Exceptional service! My package arrived on time and in perfect condition. The tracking system is incredibly accurate and easy to use."',
      review1Name: 'Reinhold Hoffmann',
      review1Role: 'Business Owner',
      review2: '"Best shipping company I\'ve ever used. Their customer support is always helpful and the delivery times are unbeatable. Highly recommended!"',
      review2Name: 'Katherine Schmidt',
      review2Role: 'E-commerce Seller',
      review3: '"Reliable, fast, and professional. I\'ve been using DutchCargoExpress for all my international shipments and they never disappoint."',
      review3Name: 'Thomas Wagner',
      review3Role: 'Import/Export Manager',
      readyToShip: 'Ready to Ship with DutchCargoExpress?',
      getQuote: 'Get Quote',
      trackPackage: 'Track Package',
    },
    tracking: {
      title: 'Track Your Shipment',
      subtitle: 'Enter your tracking number for real-time updates',
      placeholder: 'Enter tracking number (e.g., SC20231201123456)',
      trackNow: 'Track Now',
      notFound: 'Tracking Number Not Found',
      notFoundDesc: 'Please check your tracking number and try again.',
      pleaseEnter: 'Please enter a tracking number',
      tryDemo: 'Try a Demo Tracking Number',
      demoDesc: 'Want to see how our tracking system works? Click a number to try it:',
      simpleProcess: 'Simple Process',
      howTrackingWorks: 'How Tracking Works',
      howTrackingDesc: 'Three steps to get real-time updates on your shipment',
      step1Title: '1. Enter Tracking Number',
      step1Desc: 'Type your consignment tracking number into the search bar above.',
      step2Title: '2. View Live Location',
      step2Desc: 'See your package on an interactive map with real-time location data.',
      step3Title: '3. Track to Delivery',
      step3Desc: 'Follow the progress bar and history until your package is delivered.',
      secure: '100% Secure',
      secureDesc: '256-bit SSL encryption for all tracking data',
      globalCoverage: 'Global Coverage',
      globalCoverageDesc: 'Shipping to 200+ countries worldwide',
      support247: '24/7 Support',
      support247Desc: 'Expert customer service around the clock',
      needHelp: 'Need Help With Your Shipment?',
      needHelpDesc: 'Our professional support team is here to assist you',
    },
    trackingResult: {
      title: 'Tracking Result',
      intro: 'A consignment was sent to you through DutchCargoExpress. We recommend that you regularly keep track of your freight through our tracking system here. Feel free to contact us through our email in the contact page if you need any assistance of whatsoever kind.',
      detailsBelow: 'Your consignment details are as stated below',
      urgentHold: '⚠ Urgent: Shipment On Hold',
      holdDesc: 'Your shipment is currently ON HOLD and requires immediate attention. Please contact us urgently using one of the numbers below to resolve this issue and avoid delays.',
      liveMap: 'Live Shipment Map',
      originDestination: 'Origin → Destination',
      loadingMap: 'Loading map...',
      locationUnavailable: 'Location unavailable',
      origin: 'Origin',
      destination: 'Destination',
      printInvoice: 'Print Shipping Invoice',
      receiverDetails: "Receiver's Details",
      fullName: 'Full Name',
      address: 'Address',
      emailAddress: 'Email Address',
      phoneNumber: 'Phone Number',
      consignmentDetails: "Consignment's Details",
      trackingNumber: 'Tracking Number',
      status: 'Status',
      packageWeight: 'Package Weight',
      serviceType: 'Service Type',
      deliveryMode: 'Delivery Mode',
      senderDetails: "Sender's Details",
      senderName: "Sender's Name",
      senderEmail: 'Sender Email',
      shipmentRoute: 'Shipment Route & Dates',
      pickUpDate: 'PickUp Date/Time',
      expectedDelivery: 'Expected Delivery',
      trackingHistory: 'Tracking History',
      sNo: 'S/No',
      currentLocation: 'Current Location',
      facility: 'Facility',
      arrivalCountry: 'Arrival Country',
      dateTime: 'Date and Time',
      comments: 'Comments',
      noHistory: 'No tracking history available',
      na: 'N/A',
    },
    contact: {
      title: 'Get in Touch',
      subtitle: 'Have questions about shipping, tracking, or our services? Our team is available 24/7 to assist you.',
      berlinHQ: 'Berlin HQ',
      berlinDesc: 'Germany — Global Headquarters',
      usaOffice: 'USA Office',
      usaDesc: '24/7 Customer Support',
      email: 'Email',
      emailDesc: 'We respond within 24 hours',
      businessHours: 'Business Hours',
      hoursDetail: '24/7 Customer Support Available',
      hoursDesc: 'Always open for your shipping needs',
      sendMessage: 'Send Us a Message',
      formDesc: "Fill out the form below and we'll get back to you within 24 hours.",
      fullName: 'Full Name *',
      fullNamePlaceholder: 'Your full name',
      nameRequired: 'Name is required',
      emailLabel: 'Email Address *',
      emailPlaceholder: 'your@email.com',
      emailRequired: 'Email is required',
      emailInvalid: 'Invalid email address',
      subject: 'Subject *',
      subjectRequired: 'Subject is required',
      selectSubject: 'Select a subject',
      generalInquiry: 'General Inquiry',
      trackingIssue: 'Tracking Issue',
      shippingQuestion: 'Shipping Question',
      billingQuestion: 'Billing Question',
      damagedPackage: 'Damaged Package',
      lostPackage: 'Lost Package',
      complaint: 'Complaint',
      compliment: 'Compliment',
      other: 'Other',
      trackingOptional: 'Tracking Number (Optional)',
      message: 'Message *',
      messageRequired: 'Message is required',
      messageTooShort: 'Message must be at least 10 characters',
      messagePlaceholder: 'Please describe your inquiry in detail...',
      sending: 'Sending...',
      send: 'Send Message',
      sentSuccess: 'Message sent successfully!',
      sendFailed: 'Failed to send message',
      ourLocation: 'Our Location',
      globalHub: 'Global Logistics Hub',
      globalHubDesc: 'Operating across 200+ countries with 24/7 support and real-time tracking.',
      helpCenter: 'Help Center',
      faq: 'Frequently Asked Questions',
      faqDesc: 'Quick answers to common questions',
      faq1Q: 'How can I track my package?',
      faq1A: 'You can track your package using the tracking number provided in your confirmation email. Simply enter it on our tracking page or use the search box in the header.',
      faq2Q: 'What are your shipping rates?',
      faq2A: 'Our rates vary based on package size, weight, destination, and service type. Standard International starts at $185 (7-14 days), Express International at $350 (3-5 days), and Premium International at $595 (1-2 days).',
      faq3Q: 'Do you offer international shipping?',
      faq3A: 'Yes, we ship to over 200 countries worldwide. International shipping rates and delivery times vary by destination.',
      faq4Q: 'What if my package is damaged or lost?',
      faq4A: "We offer insurance options for valuable packages. If your package is damaged or lost, please contact us immediately with your tracking number and we'll investigate.",
      faq5Q: 'Can I change the delivery address after shipping?',
      faq5A: 'Address changes may be possible depending on the package status. Contact us as soon as possible with your tracking number for assistance.',
      faq6Q: 'Do you offer same-day delivery?',
      faq6A: 'Same-day delivery is available in select metropolitan areas. Please contact us to check availability in your area.',
    },
    auth: {
      adminPortal: 'Admin Portal',
      portalDesc: 'Manage shipments, track deliveries, and oversee operations across 200+ countries from a single dashboard.',
      secureAccess: 'Secure Access',
      encryption: '256-bit Encryption',
      rightsReserved: '© 2024 DutchCargoExpress. All rights reserved.',
      adminLogin: 'Admin Login',
      loginSubtitle: 'Sign in to access the admin dashboard and manage shipments.',
      email: 'Email',
      emailRequired: 'Email is required',
      emailPlaceholder: 'Enter your email',
      password: 'Password',
      passwordRequired: 'Password is required',
      passwordPlaceholder: 'Enter your password',
      signingIn: 'Signing in...',
      signIn: 'Sign in',
      contactSupport: 'Contact support for access issues',
      backHome: '← Back to homepage',
      loginSuccessful: 'Login successful!',
      loginFailed: 'Login failed',
    },
  },
  de: {
    nav: {
      shippingWorldwide: 'Versand in über 200 Länder weltweit',
      home: 'Startseite',
      track: 'Verfolgen',
      trackPackage: 'Paket verfolgen',
      contact: 'Kontakt',
      dashboard: 'Dashboard',
      logout: 'Abmelden',
      adminLogin: 'Administrator-Anmeldung',
      globalLogistics: 'Globale Logistiklösungen',
    },
    footer: {
      globalLogistics: 'Globale Logistiklösungen',
      description: 'Professionelle Versand- und Logistikdienste mit Echtzeit-Verfolgung, sicherer Lieferung und hervorragendem Kundenservice. Ihr vertrauenswürdiger Partner für alle weltweiten Versandbedürfnisse.',
      ssl: '256-Bit-SSL',
      pciCompliant: 'PCI-konform',
      ourServices: 'Unsere Dienste',
      standardDelivery: 'Standardlieferung',
      expressShipping: 'Expressversand',
      overnightDelivery: 'Übernacht-Lieferung',
      internationalShipping: 'Internationaler Versand',
      freightServices: 'Frachtdienste',
      contactUs: 'Kontakt',
      berlinHQ: 'Berlin Hauptsitz — Deutschland',
      usaOffice: 'USA-Büro — 24/7-Support',
      emailSupport: 'E-Mail-Support',
      headquarters: 'Hauptsitz',
      berlinGermany: 'Berlin, Deutschland',
      rights: '© 2024 DutchCargoExpress. Alle Rechte vorbehalten. Lizenziert & Versichert.',
      privacyPolicy: 'Datenschutz',
      termsOfService: 'Nutzungsbedingungen',
      cookiePolicy: 'Cookie-Richtlinie',
      shippingPolicy: 'Versandrichtlinie',
      trademark: 'DutchCargoExpress ist eine eingetragene Marke. Alle Sendungen unterliegen den Geschäftsbedingungen.',
    },
    home: {
      trustedBy: '🌍 Vertraut von 10M+ Kunden weltweit',
      heroTitle: 'Globale Logistik,',
      heroTitleAccent: 'Mit Präzision geliefert',
      heroDesc: 'Luft-, See- und Straßenfrachtlösungen für Unternehmen und Privatpersonen. Verfolgen Sie Ihre Pakete in Echtzeit mit unserer fortschrittlichen Logistikplattform.',
      trackPlaceholder: 'Sendungsverfolgungsnummer eingeben...',
      track: 'Verfolgen',
      orVisit: 'Oder',
      visitTracking: 'besuchen Sie unsere Tracking-Seite',
      ssl: '256-Bit-SSL',
      countries: '200+ Länder',
      onTime: '99,8 % Pünktlich',
      whatWeMove: 'Was wir transportieren',
      freightSolutions: 'Frachtlösungen für jede Route',
      freightDesc: 'Von dringender Luftfracht bis hin zu kostengünstiger Seefracht — wir kümmern uns um alles.',
      airFreight: 'Luftfracht',
      airFreightDesc: 'Express-Weltweit-Lieferung in 1–5 Werktagen mit priorisierter Zollabwicklung.',
      seaFreight: 'Seefracht',
      seaFreightDesc: 'Vollcontainer- und konsolidierter Seetransport zu allen großen Häfen weltweit.',
      doorToDoor: 'Tür-zu-Tür-Lieferung',
      doorToDoorDesc: 'Professionelle Kuriere für die letzte Meile, die sicherstellen, dass Ihr Paket sicher, unterschrieben und bestätigt ankommt.',
      ourAdvantages: 'Unsere Vorteile',
      whyChoose: 'Warum DutchCargoExpress wählen?',
      whyChooseDesc: 'Wir bieten erstklassige Versanddienste mit modernster Technologie und hervorragendem Kundenservice.',
      realTimeTracking: 'Echtzeit-Verfolgung',
      realTimeTrackingDesc: 'Verfolgen Sie Ihre Pakete in Echtzeit mit detaillierten Standortupdates und Lieferstatus.',
      secureDelivery: 'Sichere Lieferung',
      secureDeliveryDesc: 'Ihre Pakete werden sorgfältig behandelt und sicher an den richtigen Empfänger geliefert.',
      fastDelivery: 'Schnelle Lieferung',
      fastDeliveryDesc: 'Mehrere Lieferoptionen von Same-Day bis Economy-Versand, um Ihre Bedürfnisse zu erfüllen.',
      globalNetwork: 'Globales Netzwerk',
      globalNetworkDesc: 'Weltweites Versandnetzwerk, das über 200 Länder und Gebiete abdeckt.',
      pricingPlans: 'Preispläne',
      ourServices: 'Unsere Versanddienste',
      chooseService: 'Wählen Sie die perfekte Versandoption für Ihre Bedürfnisse',
      standardName: 'Standard International',
      standardTime: '7-14 Werktage',
      standardPrice: 'Ab $185',
      expressName: 'Express International',
      expressTime: '3-5 Werktage',
      expressPrice: 'Ab $350',
      premiumName: 'Premium International',
      premiumTime: '1-2 Werktage',
      premiumPrice: 'Ab $595',
      featTracking: 'Paketverfolgung',
      featDeliveryConf: 'Lieferbestätigung',
      featBasicInsurance: 'Grundversicherung',
      featCustoms: 'Zollabwicklung',
      featPriority: 'Priorisierte Bearbeitung',
      featRealTime: 'Echtzeit-Verfolgung',
      featSignature: 'Unterschrift erforderlich',
      featGuaranteed: 'Garantierte Lieferung',
      featPremiumTracking: 'Premium-Verfolgung',
      featFullInsurance: 'Vollversicherung',
      featPriorityCustoms: 'Priorisierter Zoll',
      mostPopular: 'Beliebteste',
      getStarted: 'Loslegen',
      packagesDelivered: 'Pakete geliefert',
      countriesServed: 'Länder bedient',
      onTimeDelivery: 'Pünktliche Lieferung',
      customerSupport: 'Kundenservice',
      customerReviews: 'Kundenbewertungen',
      whatCustomersSay: 'Was unsere Kunden sagen',
      joinThousands: 'Schließen Sie sich Tausenden zufriedener Kunden an, die uns mit ihren Versandbedürfnissen vertrauen',
      review1: '"Hervorragender Service! Mein Paket kam pünktlich und in einwandfreiem Zustand an. Das Tracking-System ist unglaublich genau und benutzerfreundlich."',
      review1Name: 'Reinhold Hoffmann',
      review1Role: 'Unternehmensinhaber',
      review2: '"Beste Versandfirma, die ich je benutzt habe. Der Kundenservice ist immer hilfsbereit und die Lieferzeiten sind unschlagbar. Sehr empfehlenswert!"',
      review2Name: 'Katherine Schmidt',
      review2Role: 'E-Commerce-Verkäufer',
      review3: '"Zuverlässig, schnell und professionell. Ich nutze DutchCargoExpress für alle meine internationalen Sendungen und sie enttäuschen nie."',
      review3Name: 'Thomas Wagner',
      review3Role: 'Import/Export-Manager',
      readyToShip: 'Bereit, mit DutchCargoExpress zu versenden?',
      getQuote: 'Angebot anfordern',
      trackPackage: 'Paket verfolgen',
    },
    tracking: {
      title: 'Sendung verfolgen',
      subtitle: 'Geben Sie Ihre Sendungsverfolgungsnummer für Echtzeit-Updates ein',
      placeholder: 'Sendungsverfolgungsnummer eingeben (z.B. SC20231201123456)',
      trackNow: 'Jetzt verfolgen',
      notFound: 'Sendungsverfolgungsnummer nicht gefunden',
      notFoundDesc: 'Bitte überprüfen Sie Ihre Sendungsverfolgungsnummer und versuchen Sie es erneut.',
      pleaseEnter: 'Bitte geben Sie eine Sendungsverfolgungsnummer ein',
      tryDemo: 'Demo-Verfolgungsnummer ausprobieren',
      demoDesc: 'Möchten Sie sehen, wie unser Tracking-System funktioniert? Klicken Sie auf eine Nummer, um es auszuprobieren:',
      simpleProcess: 'Einfacher Prozess',
      howTrackingWorks: 'So funktioniert die Verfolgung',
      howTrackingDesc: 'Drei Schritte zu Echtzeit-Updates Ihrer Sendung',
      step1Title: '1. Verfolgungsnummer eingeben',
      step1Desc: 'Geben Sie Ihre Sendungsverfolgungsnummer in die Suchleiste oben ein.',
      step2Title: '2. Live-Standort anzeigen',
      step2Desc: 'Sehen Sie Ihr Paket auf einer interaktiven Karte mit Echtzeit-Standortdaten.',
      step3Title: '3. Bis zur Lieferung verfolgen',
      step3Desc: 'Folgen Sie dem Fortschrittsbalken und der Historie, bis Ihr Paket geliefert ist.',
      secure: '100 % Sicher',
      secureDesc: '256-Bit-SSL-Verschlüsselung für alle Tracking-Daten',
      globalCoverage: 'Globale Abdeckung',
      globalCoverageDesc: 'Versand in über 200 Länder weltweit',
      support247: '24/7-Support',
      support247Desc: 'Fachkundiger Kundenservice rund um die Uhr',
      needHelp: 'Brauchen Sie Hilfe mit Ihrer Sendung?',
      needHelpDesc: 'Unser professionelles Support-Team ist hier, um Ihnen zu helfen',
    },
    trackingResult: {
      title: 'Verfolgungsergebnis',
      intro: 'Eine Sendung wurde über DutchCargoExpress an Sie gesendet. Wir empfehlen, Ihre Fracht regelmäßig über unser Tracking-System zu verfolgen. Wenden Sie sich gerne über unsere E-Mail auf der Kontaktseite an uns, wenn Sie jegliche Art von Unterstützung benötigen.',
      detailsBelow: 'Ihre Sendungsdetails sind wie folgt angegeben',
      urgentHold: '⚠ Dringend: Sendung pausiert',
      holdDesc: 'Ihre Sendung ist derzeit PAUSIERT und erfordert sofortige Aufmerksamkeit. Bitte kontaktieren Sie uns dringend über eine der untenstehenden Nummern, um dieses Problem zu lösen und Verzögerungen zu vermeiden.',
      liveMap: 'Live-Sendungskarte',
      originDestination: 'Ursprung → Ziel',
      loadingMap: 'Karte wird geladen...',
      locationUnavailable: 'Standort nicht verfügbar',
      origin: 'Ursprung',
      destination: 'Ziel',
      printInvoice: 'Versandrechnung drucken',
      receiverDetails: 'Empfängerdetails',
      fullName: 'Vollständiger Name',
      address: 'Adresse',
      emailAddress: 'E-Mail-Adresse',
      phoneNumber: 'Telefonnummer',
      consignmentDetails: 'Sendungsdetails',
      trackingNumber: 'Verfolgungsnummer',
      status: 'Status',
      packageWeight: 'Paketgewicht',
      serviceType: 'Servicetyp',
      deliveryMode: 'Liefermodus',
      senderDetails: 'Absenderdetails',
      senderName: 'Absendername',
      senderEmail: 'Absender-E-Mail',
      shipmentRoute: 'Sendungsroute & Daten',
      pickUpDate: 'Abholdatum/Zeit',
      expectedDelivery: 'Erwartete Lieferung',
      trackingHistory: 'Verfolgungshistorie',
      sNo: 'Nr.',
      currentLocation: 'Aktueller Standort',
      facility: 'Einrichtung',
      arrivalCountry: 'Ankunftsland',
      dateTime: 'Datum und Uhrzeit',
      comments: 'Kommentare',
      noHistory: 'Keine Verfolgungshistorie verfügbar',
      na: 'k.A.',
    },
    contact: {
      title: 'Kontakt aufnehmen',
      subtitle: 'Fragen zum Versand, Tracking oder unseren Diensten? Unser Team ist rund um die Uhr für Sie da.',
      berlinHQ: 'Berlin Hauptsitz',
      berlinDesc: 'Deutschland — Globaler Hauptsitz',
      usaOffice: 'USA-Büro',
      usaDesc: '24/7-Kundenservice',
      email: 'E-Mail',
      emailDesc: 'Wir antworten innerhalb von 24 Stunden',
      businessHours: 'Geschäftszeiten',
      hoursDetail: '24/7-Kundenservice verfügbar',
      hoursDesc: 'Immer für Ihre Versandbedürfnisse geöffnet',
      sendMessage: 'Nachricht senden',
      formDesc: 'Füllen Sie das untenstehende Formular aus und wir melden uns innerhalb von 24 Stunden bei Ihnen.',
      fullName: 'Vollständiger Name *',
      fullNamePlaceholder: 'Ihr vollständiger Name',
      nameRequired: 'Name ist erforderlich',
      emailLabel: 'E-Mail-Adresse *',
      emailPlaceholder: 'ihre@email.com',
      emailRequired: 'E-Mail ist erforderlich',
      emailInvalid: 'Ungültige E-Mail-Adresse',
      subject: 'Betreff *',
      subjectRequired: 'Betreff ist erforderlich',
      selectSubject: 'Betreff auswählen',
      generalInquiry: 'Allgemeine Anfrage',
      trackingIssue: 'Tracking-Problem',
      shippingQuestion: 'Versandfrage',
      billingQuestion: 'Rechnungsfrage',
      damagedPackage: 'Beschädigtes Paket',
      lostPackage: 'Verlorenes Paket',
      complaint: 'Beschwerde',
      compliment: 'Kompliment',
      other: 'Sonstiges',
      trackingOptional: 'Verfolgungsnummer (optional)',
      message: 'Nachricht *',
      messageRequired: 'Nachricht ist erforderlich',
      messageTooShort: 'Die Nachricht muss mindestens 10 Zeichen lang sein',
      messagePlaceholder: 'Bitte beschreiben Sie Ihre Anfrage im Detail...',
      sending: 'Wird gesendet...',
      send: 'Nachricht senden',
      sentSuccess: 'Nachricht erfolgreich gesendet!',
      sendFailed: 'Nachricht konnte nicht gesendet werden',
      ourLocation: 'Unser Standort',
      globalHub: 'Globales Logistikzentrum',
      globalHubDesc: 'Aktiv in über 200 Ländern mit 24/7-Support und Echtzeit-Verfolgung.',
      helpCenter: 'Hilfecenter',
      faq: 'Häufig gestellte Fragen',
      faqDesc: 'Schnelle Antworten auf häufige Fragen',
      faq1Q: 'Wie kann ich mein Paket verfolgen?',
      faq1A: 'Sie können Ihr Paket mit der Sendungsverfolgungsnummer aus Ihrer Bestätigungs-E-Mail verfolgen. Geben Sie diese einfach auf unserer Tracking-Seite oder in das Suchfeld oben ein.',
      faq2Q: 'Wie hoch sind Ihre Versandraten?',
      faq2A: 'Unsere Raten variieren je nach Paketgröße, Gewicht, Ziel und Servicetyp. Standard International ab $185 (7-14 Tage), Express International ab $350 (3-5 Tage), Premium International ab $595 (1-2 Tage).',
      faq3Q: 'Bieten Sie internationalen Versand an?',
      faq3A: 'Ja, wir versenden in über 200 Länder weltweit. Internationale Versandraten und Lieferzeiten variieren je nach Ziel.',
      faq4Q: 'Was ist, wenn mein Paket beschädigt oder verloren ist?',
      faq4A: 'Wir bieten Versicherungsoptionen für wertvolle Pakete an. Wenn Ihr Paket beschädigt oder verloren ist, kontaktieren Sie uns bitte sofort mit Ihrer Verfolgungsnummer und wir werden es untersuchen.',
      faq5Q: 'Kann ich die Lieferadresse nach dem Versand ändern?',
      faq5A: 'Adressänderungen können je nach Paketstatus möglich sein. Kontaktieren Sie uns so schnell wie möglich mit Ihrer Verfolgungsnummer für Hilfe.',
      faq6Q: 'Bieten Sie Same-Day-Lieferung an?',
      faq6A: 'Same-Day-Lieferung ist in ausgewählten Ballungsräumen verfügbar. Bitte kontaktieren Sie uns, um die Verfügbarkeit in Ihrer Region zu prüfen.',
    },
    auth: {
      adminPortal: 'Administrator-Portal',
      portalDesc: 'Verwalten Sie Sendungen, verfolgen Sie Lieferungen und überwachen Sie Vorgänge in über 200 Ländern über ein einziges Dashboard.',
      secureAccess: 'Sicherer Zugriff',
      encryption: '256-Bit-Verschlüsselung',
      rightsReserved: '© 2024 DutchCargoExpress. Alle Rechte vorbehalten.',
      adminLogin: 'Administrator-Anmeldung',
      loginSubtitle: 'Melden Sie sich an, um auf das Administrator-Dashboard zuzugreifen und Sendungen zu verwalten.',
      email: 'E-Mail',
      emailRequired: 'E-Mail ist erforderlich',
      emailPlaceholder: 'Geben Sie Ihre E-Mail ein',
      password: 'Passwort',
      passwordRequired: 'Passwort ist erforderlich',
      passwordPlaceholder: 'Geben Sie Ihr Passwort ein',
      signingIn: 'Anmeldung...',
      signIn: 'Anmelden',
      contactSupport: 'Support bei Zugangsproblemen kontaktieren',
      backHome: '← Zurück zur Startseite',
      loginSuccessful: 'Anmeldung erfolgreich!',
      loginFailed: 'Anmeldung fehlgeschlagen',
    },
  },
};
